<script>
import support from "@/utils/support";

import Accordion from "@/components/_Shared/Accordion";
import Support from "@/components/Support/Index";

export default {
  components: {
    Accordion,
    Support
  },

  props: {
    rules: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data() {
    return {
      supportModalOpen: false
    };
  },

  methods: {
    openSupport() {
      support.openChat();
    },

    openSupportProofOfPayment() {
      support.sendProofOfPayment();
    }
  }
};
</script>

<template>
  <section>
    <Support v-if="supportModalOpen" @close="supportModalOpen = false" />

    <accordion title="Se você precisar de suporte da Donamaid utilize" :opened="true">
      <ul class="no-dots">
        <li>
          o nosso chat <span class="link" @click="openSupport">clicando aqui</span> ou no icone localizado no canto inferior direito em horário comercial
        </li>
        <li>Abrir um ticket <span class="link" @click="supportModalOpen = true">clicando aqui</span></li>
        <li>o e-mail suporte@donamaid.com</li>
        <li>entre em contato conosco pelo  <a href="https://www.facebook.com/donamaidbrasil" target="_blank" rel="noopener noreferrer">facebook</a> ou  <a href="https://www.instagram.com/donamaid" target="_blank" rel="noopener noreferrer">instagram</a></li>

        <h4 class="mb-0">Horário de atendimento:</h4>
        <p class="mt-0">
          Segunda à sexta das 8h às 18h
          <br />Sábado das 8h às 14h
        </p>
      </ul>
    </accordion>

    <accordion v-if="rules" title="Regras" :opened="true">
      <ul>
        <li>Você pode reagendar ou cancelar um pedido gratuitamente comunicando com até 24h úteis de antecedência</li>
        <li>Você pode reagendar ou cancelar entre 24h e 3h úteis de antecedência perdendo 1h de duração da sua limpeza</li>
        <li>Você não pode reagendar ou cancelar um pedido com menos de 3h úteis de antecedência. Neste caso, se o profissional não puder ser recebido em dia e hora previamente marcados, a limpeza é considerada completa e o profissional recebe o valor normalmente</li>
        <li>A responsabilidade pelo comparecimento na limpeza é do profissional autônomo escolhido, em caso de faltas, a Donamaid fará todo o possível para realizar a substituição do profissional de acordo com as preferências previamente definidas pelo cliente no momento da realização do pedido</li>
      </ul>
    </accordion>

    <accordion title="Produtos de limpeza" :opened="true">
      <ul>
        <li>Por padrão, os produtos de limpeza devem ser disponibilizados pelo cliente no dia da limpeza.</li>
        <li>No momento do agendamento o cliente pode solicitar que o profissional leve os produtos de limpeza mediante o pagamento de um valor adicional.</li>
        <li>A opção de pagar um valor adicional para o profissional levar os produtos de limpeza não está disponível em todas as cidades. Verifique a disponibilidade e entre em contato com o nosso suporte caso tenha alguma dúvida.</li>
      </ul>
      <accordion title="do usuário cliente">
        <p><b>Caso você prefira utilizar os seus produtos de limpeza</b>, eles devem estar a disposição do profissional no dia e local da limpeza. Você também precisa fornecer utensílios que forem necessários, como:</p>
        <ul>
          <li>Balde</li>
          <li>Vassoura</li>
          <li>Escada</li>
          <li>EPI's</li>
          <li>Outros produtos e utensílios que não estejam inclusos na lista de produtos ou quantidades extras dos produtos fornecidos pelo profissional.</li>
        </ul>
      </accordion>

      <accordion title="do profissional autônomo">
        <p><b>Quando requisitado pelo cliente no momento do agendamento</b>, o profissional deve fornecer:</p>
        <ul>
          <li>(500ml) Desinfetante de uso geral</li>
          <li>(200ml) Limpador multiuso</li>
          <li>(200ml) Detergente</li>
          <li>(500ml) Água sanitária</li>
          <li>(1 par) de Luvas de borracha</li>
          <li>(3) Panos de chão</li>
          <li>(3) Flanelas</li>
          <li>(1) Esponja</li>
          <li>(1) Esponja de aço</li>
          <li>(2) Sacos de lixo</li>
        </ul>
        <p>Os produtos de limpeza inclusos não utilizados, permanecerão com o profissional.</p>
      </accordion>
    </accordion>

    <accordion title="Responsabilidades" :opened="true">
      <accordion title="da Donamaid">
        <ul>
          <li>Verificar a veracidade do cadastro dos profissionais autônomos</li>
          <li>Manter as avaliações dos profissionais atualizadas</li>
          <li>Gerir o pagamento das limpezas</li>
          <li>Fornecer suporte para comunicação entre profissional e cliente</li>
        </ul>
      </accordion>

      <accordion title="do profissional autônomo">
        <ul>
          <li>Comparecer às limpezas no horário agendado</li>
          <li>Cumprir toda a carga horária contratada</li>
          <li>Otimizar o tempo de limpeza</li>
          <li>A qualidade da limpeza</li>
          <li>Os produtos de limpeza da lista padrão quando solicitado pelo cliente no agendamento</li>
          <li>Alinhar com o cliente as atividades a serem realizadas</li>
          <li>Seguir as prioridades de limpeza do cliente</li>
          <li>Pedir ao cliente aos 30 minutos finais da limpeza a revisão do serviço prestado</li>
          <li>Seguir todas as regras do aplicativo Donamaid</li>
        </ul>
      </accordion>

      <accordion title="do usuário cliente">
        <ul>
          <li>
            Pagar o boleto antes do vencimento e enviar o comprovante de pagamento através de
            <b
              class="pointer"
              @click="openSupportProofOfPayment"
            >ticket</b> com até 48h úteis antes da limpeza se a compra ocorrer com menos de 4 dias úteis de antecedência.
          </li>
          <li>Prover o acesso do profissional ao local da limpeza no horário agendado com tolerância de atraso do cliente de até 30 minutos</li>
          <li>Fornecer os produtos(apenas quando optar por utilizar os seus produtos) e utensílios necessários para realizar a limpeza</li>
          <li>Ao início da limpeza, alinhar com o profissional todas as atividades a serem realizadas no tempo contratado, estabelecendo as prioridades</li>
          <li>Ser sincero(a) durante a limpeza quando questionado(a) pelo profissional ou ser proativo sobre a qualidade do serviço prestado</li>
          <li>Fazer avaliação sincera e descritiva do profissional autônomo pelo formulário de avaliação recebido por e-mail ao final da limpeza</li>
          <li>Solicitar horas extras de limpeza, caso necessário, pelos canais de atendimento Donamaid</li>
          <li>Notificar pelos canais de atendimento Donamaid quando permitida a saída do profissional antes do término acordado</li>
        </ul>
      </accordion>
    </accordion>
  </section>
</template>

<style scoped>
.link {
  font-weight: 500;
  color: #603285;
  cursor: pointer;
}

p {
  margin: 0;
}

.no-dots {
  list-style: none;
  padding-left: 0;
}

.no-dots li {
  background: url("/static/icon_order_status_ok.svg") no-repeat 0 6px;
  background-size: 15px 15px;
  padding-left: 20px;
  line-height: 25px;
}

.no-dots li img {
  transform: translateY(3px);
}

.no-dots li.dont-use {
  background: url("/static/icon-error.svg") no-repeat 0 6px;
  background-size: 15px 15px;
}

section {
  width: 100%;
}

a {
  font-weight: 500;
}
ul {
  padding-left: 17px;
}

@media (min-width: 668px) {
  ul {
    padding-left: 40px;
  }

  .no-dots {
    padding-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/FAQ.vue